import styled from 'styled-components';

import media from 'apps/auth/theme/media';
import zIndex from 'apps/auth/theme/zIndex';

export const Container = styled.section`
    background-color: ${(props) => props.theme.white};
    box-shadow:
        0 0 1px rgb(20 20 20 / 12%),
        0 -2px 12px rgb(20 20 20 / 4%);
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    z-index: ${zIndex.leftMenuIndex};
`;

export const Menu = styled.ul`
    display: flex;
    justify-content: center;
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    box-sizing: border-box;

    ${media.tablet720} {
        padding-left: 112px;
        padding-right: 112px;
        max-width: none;
    }

    ${media.desktop1224} {
        padding-left: 40px;
        padding-right: 40px;
    }
`;

// Menu item

interface ItemContainerProps {
    isSelected?: boolean;
}

export const ItemContainer = styled.li<ItemContainerProps>`
    width: 50%;
    color: ${(props) => (props.isSelected ? props.theme.black : props.theme.grey_72_lc)};
`;

export const MenuLink = styled.a`
    font-family: var(--font-tag), sans-serif;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: auto;
    font-size: 8px;
    letter-spacing: 0.09em;
    line-height: 10px;
    padding-bottom: 4px;
    padding-top: 6px;
    text-transform: uppercase;
    justify-content: center;

    ${media.tablet720} {
        font-size: 11px;
        letter-spacing: 0.08em;
        line-height: 16px;
        padding-bottom: 8px;
        padding-top: 10px;
    }

    ${media.desktop1224} {
        font-family: var(--font-main), sans-serif;
        flex-direction: row;
        font-size: 17px;
        line-height: 24px;
        letter-spacing: normal;
        padding: 28px 32px;
        text-transform: none;
        &:hover {
            background: ${(props) => props.theme.grey_8_lc};
        }
    }

    ${media.desktop1920} {
        font-size: 20px;
        line-height: 32px;
        padding: 32px;
    }
`;

export const IconWrapper = styled.span`
    height: 24px;
    position: relative;
    margin-bottom: 4px;

    ${media.tablet720} {
        margin-bottom: 6px;
    }

    ${media.desktop1224} {
        margin-bottom: 0;
        margin-right: 24px;
    }
`;

export const NavigationMenuText = styled.span`
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
`;
